// Preferences.js

import React, { useState } from 'react';
import Checkbox from '../../shared/Checkbox';

function Preferences({
  preferences,
  selectedPreferences = [],
  onPreferenceChange,
}) {
  const [currentPreferences, setCurrentPreferences] = useState(selectedPreferences)

  const handlePreferenceChange = (preference) => {
    const updatedPreferences = currentPreferences.includes(preference)
      ? currentPreferences.filter((pref) => pref !== preference)
      : [...currentPreferences, preference];

    setCurrentPreferences(updatedPreferences);
    onPreferenceChange(updatedPreferences);
  };

  return (
    <div className="bg-gray-50 p-5 rounded-xl border border-gray-200 h-full">
      <h3 className="text-lg font-bold text-rd-navy mb-4 flex items-center">
        <span className="text-2xl mr-2">⚙️</span>
        Preferências
      </h3>
      <ul className="space-y-3">
        {preferences.map((preference, index) => (
          <li key={index} className="transition-all duration-200 hover:translate-x-1">
            <Checkbox
              value={preference}
              checked={currentPreferences.includes(preference)}
              onChange={() => handlePreferenceChange(preference)}
              className="text-rd-blue"
            >
              {preference}
            </Checkbox>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Preferences;
